import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Redirect, Route, RouteComponentProps, Switch, withRouter } from 'react-router';
import VisibilitySensor from 'react-visibility-sensor';
import { SpeechesData } from '../stores';
import { ScrollTo } from './ScrollTo';
import { Stats } from './Stats';
import styles from './Talks.styl';
import { YearRouteComponent } from './YearRouteComponent';
import { YearSelect } from './YearSelect';

@(withRouter as ClassDecorator)
@inject('speeches')
@observer
export class Talks extends React.Component<{ speeches: SpeechesData } & Partial<RouteComponentProps<{}>>> {
    render() {
        const { speeches, match } = this.props;
        return (
            <div className={styles.talks}>
                <VisibilitySensor scrollCheck resizeCheck scrollDelay={1000} intervalCheck={false} partialVisibility>
                    {({ isVisible }) => (
                        <div>
                            <Route path={match.url + '/:year?/:link?'} render={({ match }) => (
                                <ScrollTo when={!match.params.link && !isVisible} />
                            )} />
                            <Stats speeches={speeches} />
                            <YearSelect path={match.url} />
                        </div>
                    )}
                </VisibilitySensor>
                <Switch>
                    <Route path={match.url + '/:year'} component={YearRouteComponent} />
                    {speeches.years.length && <Redirect to={match.url + '/' + speeches.years.slice(-1)} />}
                </Switch>
            </div>
        );
    }
}

